/**
 * Copyright 2022 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import { SectionRowElementChart, SectionRowElementChartColorGradient } from '@umati/dashboard-types';
import Override from 'components/machine/override';
import SectionData from 'components/machine/sectionData';
import React, { Component } from 'react';
import TemplateHelper from 'utilities/TemplateHelper';

interface SectionElementContentChartProps {
  element: SectionRowElementChart;
  cols: string;
  data: any;
  label: string;
}

interface SectionElementContentChartState {}

export default class SectionElementContentChart extends Component<
  SectionElementContentChartProps,
  SectionElementContentChartState
> {
  constructor(props: SectionElementContentChartProps) {
    super(props);
    this.state = {};
  }

  render() {
    const amount: number = TemplateHelper.getChartAmount(this.props.data, this.props.element.valueVariable);
    const symbol: string | undefined = TemplateHelper.getVariableUnit(
      this.props.data,
      this.props.element.valueVariable,
      this.props.element.customUnit,
    );
    const rangeMax: number = TemplateHelper.getVariableRangeMax(
      this.props.data,
      this.props.element.valueVariable,
      this.props.element.customRangeHigh,
    );
    const rangeMin: number = TemplateHelper.getVariableRangeMin(
      this.props.data,
      this.props.element.valueVariable,
      this.props.element.customRangeLow,
    );
    const colorGradient: SectionRowElementChartColorGradient | undefined = TemplateHelper.getChartColorGradient(
      this.props.element,
      amount,
      this.props.data,
    );
    return (
      <SectionData cols={this.props.cols} label={this.props.label}>
        <Override amount={amount} symbol={symbol} max={rangeMax} min={rangeMin} colorGradient={colorGradient} />
      </SectionData>
    );
  }
}
